const swiper = new Swiper('.rltm-post-swiper', {
	slidesPerView: 1,
	spaceBetween: 16,
	watchSlidesProgress: true,
	loop: true,
	breakpoints: {
		768: {
			slidesPerView: 1,
			spaceBetween: 20,
		},
		960: {
			slidesPerView: 1,
			spaceBetween: 20,
		},
	},
	navigation: {
		nextEl: '.rltm-post-swiper-button-next',
		prevEl: '.rltm-post-swiper-button-prev',
	},
	pagination: {
		el: '.rltm-post-swiper-pagination',
		clickable: true,
	},
});
